module.exports = __webpack_public_path__ + "brand-icons.e8e86d7417f45bf14e99.woff2";


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/fonts/brand-icons/brand-icons.woff2?v=0.3.2
// module id = ../../../../../src/fonts/brand-icons/brand-icons.woff2?v=0.3.2
// module chunks = styles